import { useEffect, useState } from "react";
import { bool, func } from "prop-types";
import { useTranslation } from "react-i18next";
import { getPaymentHistoryQuery } from "@query";
import { universalDateParser, formatPriceWithCurrency } from "@utils";
import { makeStyles } from "@material-ui/styles"
import { format } from "date-fns";
import { Dialog, Table, TableCell, TableRow } from "@components";
import { CircularProgress, IconButton, Link } from "@material-ui/core";
import { Receipt } from "@material-ui/icons";

export const PaymentHistoryDialog = ({ open, onClose }) => {
  const { t } = useTranslation();
  const classes = useStyle();

  const [isLoading, setIsLoading] = useState(false);
  const [hasMore/*, setHasMore*/] = useState(false);
  const [payments, setPayments] = useState([]);

  const loadPayments = async (resetList = false) => {
    if (resetList || (!isLoading && hasMore)) {
      setIsLoading(true);
      const res = await getPaymentHistoryQuery(
        resetList ? null : payments[payments.length - 1].id
      );
      if (res) {
        setPayments(resetList ? res : [...payments, ...res]);
        // setHasMore(res.paginate.hasMore);
      }
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (open) loadPayments(true);
  }, [open]);

  return (
    <Dialog
      open={open}
      onClose={() => onClose()}
      width={900}
      title={t("views.subscription.dialogs.history")}
    >
      <Table
        id="paymentHistory"
        scrollEndHandler={hasMore ? loadPayments : null}
        headers={[
          { label: t("views.subscription.type"), width: 340 },
          { label: t("views.subscription.date"), width: 120 },
          { label: t("views.subscription.amount_gross"), width: 120 },
          { label: t("views.subscription.status"), width: 120 },
          { width: 36 },
        ]}
      >
        {
          payments
          // .filter(p => p.detail?.length && p.stripeInvoicePdf)
          .map(({ id, description, createdAt, amount, status, receiptUrl, refunded, amountRefunded, currency }) => (
            <TableRow key={id}>
              <TableCell width={340}>
                { description && <p>{description}</p>}
              </TableCell>
              <TableCell width={120}>
                {format(universalDateParser(createdAt), "dd.MM.yyyy")}
              </TableCell>
              <TableCell width={120}>
                <strong>
                  {formatPriceWithCurrency(amount, currency)}
                </strong>
              </TableCell>
              <TableCell width={120}>
                <span style={{ textTransform: "capitalize" }}>
                  {t(`views.subscription.payment_status.${status}`)}
                </span>
                {refunded && (
                  <span className={classes.refundedBadge}>
                    {t("views.subscription.payment_status.refunded")}: {formatPriceWithCurrency(amountRefunded, currency)}
                  </span>
                )}
              </TableCell>
              <TableCell width={36}>
                {
                  receiptUrl &&
                  <Link href={receiptUrl} target="_blank">
                    <IconButton color="primary">
                      <Receipt />
                    </IconButton>
                  </Link>
                }
              </TableCell>
            </TableRow>
          ))
        }
        {
          isLoading &&
          <CircularProgress
            aria-label="progress indicator"
            className={classes.spinner}
          />
        }
      </Table>
    </Dialog>
  );
};

const useStyle = makeStyles((theme) => ({
  spinner: {
    position: "relative",
    left: "calc(50% - 20px)",
    margin: 10,
  },
  refundedBadge: {
    display: "block",
    fontSize: 11,
    color: theme.palette.error.main,
    fontWeight: 500,
    marginTop: 2,
  },
}));

PaymentHistoryDialog.propTypes = {
  open: bool.isRequired,
  onClose: func.isRequired,
};
